import type { FC } from "react";
import {
	ClientPortfolioToolIdentificationTypeEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { ToolRowCommonProps } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { ToolRowWrapper } from "./ToolRowWrapper";

const PageResources = Resources.PortfolioDetail;

export const DefaultToolRow: FC<ToolRowCommonProps> = ({
	tool,
	toolIdx,
	portfolioId,
	expanded,
	onToggle,
	noDivider,
}) => {
	const { t } = useResource();

	return (
		<ToolRowWrapper
			label={tool.name ?? ""}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
			portfolioId={portfolioId}
			toolIdx={toolIdx}
		>
			<DataRow
				label={t(PageResources.LifeInsurance.InvestmentTool.type)}
				value={t(
					PageResources.LifeInsurance.InvestmentTool.Type[
						tool.type ?? ClientPortfolioToolTypeEnum.Other
					],
				)}
			/>
			<DataRow
				label={t(
					PageResources.LifeInsurance.InvestmentTool.IdentificationType[
						tool.identificationType ??
							ClientPortfolioToolIdentificationTypeEnum.None
					],
				)}
				value={tool.identification}
			/>
		</ToolRowWrapper>
	);
};
